import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const AppointmentOverview = React.lazy(() =>
  import('../../views/AppointmentOverview')
);

const params = [];
const AppointmentOverviewRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout>
        <AppointmentOverview />
      </Layout>
    </RouteParameter>
  );
};

AppointmentOverviewRoute.propTypes = {};

AppointmentOverviewRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(AppointmentOverviewRoute);
